export default {
  notification: {
    type: 'success',
    visible: false,
    message: undefined,
    timeoutInSeconds: 0,
  },
  notificationsCount: 0,
};
